const state = {
  layananApiScan: {
    qr: "",
    limit: "0",
    skip: "0",
    search: "",
  },
  dataLayanan: [],
  akunEpay: {},

  dataCustomer: {
    id: "",
    idcustomer: "",
    namaoutlet: "",
    idoutlet: "",
    namacustomer: "",
    saldocustomer: 0,
  },

  dataPesanan: {
    idmesin: "",
    idsnap_layanan: "",
    total: 0,
    grandtotal: 0,
    namaMesin: "",
    namaLayanan: "",
    durasiLayanan: 0,
    idOutlet: "",
  },
  dataGlobalCustomer: {},
};

export default state;
